export const isSnapshot = (
  snapshotEnv: string = process.env.SNAPSHOT
): boolean => {
  return snapshotEnv === 'true';
};
